import { Typography } from '@euler/app/components/typography';
import { InspectionSiteGridView } from '@euler/app/flows/task/pages/inspection/components/InspectionSiteGrid';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useAdaptiveContainerWidth } from '@euler/functions/useAdaptiveContainerWidth';
import { useGeneralBottomSheetModal } from '@euler/functions/useBottomSheetModal';
import { BottomSheetModal, BottomSheetScrollView } from '@gorhom/bottom-sheet';
import { memo } from 'react';
import { Platform, ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ItemInfo } from '../functions/InspectionSiteGrid';

type Props = {
  show?: boolean;
  items: ItemInfo[];
  topMargin?: number;
  onSelect?: (item: ItemInfo) => void;
  onDismiss?: () => void;
};

export const HiddenSiteBottomSheet = memo(
  ({ show, items, onSelect, topMargin, onDismiss }: Props) => {
    const insets = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();
    const { bottomSheetModalRef, ...bottomSheetProps } =
      useGeneralBottomSheetModal({
        show,
        topMargin,
        onDismiss,
      });
    const width = useAdaptiveContainerWidth();

    // Fix: BottomSheet specific scroll view components do not work on Web right now.
    // https://github.com/gorhom/react-native-bottom-sheet/issues/11
    const ScrollComponent =
      Platform.OS === 'web' ? ScrollView : BottomSheetScrollView;

    return (
      <BottomSheetModal ref={bottomSheetModalRef} {...bottomSheetProps}>
        <ScrollComponent
          contentContainerStyle={{
            paddingTop: rpx(15),
            paddingBottom: insets.bottom + rpx(15),
          }}
        >
          {!items.length ? (
            <Center
              css={`
                padding: ${rpx(32)}px;
              `}
            >
              <Typography.Label light size={rpx(15)} color="#666">
                暂无更多部位
              </Typography.Label>
            </Center>
          ) : null}
          <InspectionSiteGridView
            width={width}
            items={items}
            onCellPress={onSelect}
          />
        </ScrollComponent>
      </BottomSheetModal>
    );
  },
);
